import type { ComponentProps, ReactNode } from "react";

import { cn } from "../utils";
import { Spinner } from "./loading";
import { Separator } from "./separator";

export const Column = ({ className, ...props }: ComponentProps<"div">) => (
  <div className={cn("bg-card [&>*]:bg-inherit flex flex-1 flex-col h-full overflow-y-auto", className)} {...props} />
);

export type ColumnHeaderProps = ComponentProps<"header"> & {
  icon?: ReactNode;
  loading?: boolean;
};

export const ColumnHeader = ({ className, children, icon, loading, ...props }: ColumnHeaderProps) => (
  <header
    className={cn(
      "bg-inherit last-of-type:border-b flex-none p-2 pb-0 last-of-type:pb-2 sticky top-0 z-2",
      icon && "pl-0",
      className
    )}
    {...props}
  >
    <div className="bg-inherit flex h-8 items-center">
      {icon && <Gutter>{loading ? <Spinner className="text-sm" /> : icon}</Gutter>}
      {children}
    </div>
  </header>
);

export const ColumnFooter = ({ className, ...props }: ComponentProps<"footer">) => (
  <footer
    className={cn(
      "bg-clip-padding bg-inherit border-t border-t-foreground/7.5 flex flex-none h-(--gutter) items-center justify-between px-3 sticky bottom-0 z-2",
      className
    )}
    {...props}
  />
);

export const ColumnContent = ({ className, ...props }: ComponentProps<"div">) => (
  <div className={cn("flex-auto overflow-y-auto", className)} {...props} />
);

export const Gutter = ({ className, ...props }: ComponentProps<"div">) => (
  <div className={cn("flex flex-none items-center justify-center w-(--gutter)", className)} {...props} />
);

export const GutterSeparator = () => <Separator className="last:hidden ml-(--gutter) opacity-50 w-auto" />;
